import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'

export const SELF = 'SELF'
export const OTHER = 'OTHER'

const SelectUser = ({onSelectUser, employee}) => {
  const localeState = useLocaleState()

  const onSelectSelf = () => {
    onSelectUser(SELF)
  }

  const onSelectAnotherUser = () => {
    onSelectUser(OTHER)
  }

  const employeeName = employee.name || employee.em_id

  return (
    <Container>
      <StyledBorder>
        <TitleText>{_L({key: 'Booking for:', localeState})}</TitleText>
        <UserContainer onClick={onSelectSelf} data-testid="select-self">
          <UserTitle>{_L({key: 'Myself', localeState})}</UserTitle>
          <UserText>{employeeName}</UserText>
        </UserContainer>
        <UserContainer
          onClick={onSelectAnotherUser}
          data-testid="select-another"
        >
          <UserTitle>{_L({key: 'Another Person', localeState})}</UserTitle>
        </UserContainer>
      </StyledBorder>
    </Container>
  )
}
export default SelectUser

const Container = styled.div`
  width: 600px;
  height: 260px;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: 630px) {
    width: 100vw;
    height: calc(100vh - 80px);
    border-radius: 0;
  }

  @media (max-width: 420px) {
    height: calc(100vh - 44px);
    border-radius: 0;
  }
`

const StyledBorder = styled.div`
  padding: 32px;
`

const TitleText = styled.div`
  font-size: 14px;
  color: #a4a9b7;
  padding: 0px 0px 16px 0px;
`

const UserTitle = styled(TitleText)`
  font-weight: bold;
  color: #000000;
  padding: 0px 0px 0px 32px;
  text-align: left;
  width: 50%;
`

const UserText = styled(TitleText)`
  font-weight: bold;
  padding-right: 32px;
  text-align: right;
  width: 50%;
`

const UserContainer = styled.div`
  width: 100%;
  height: 64px;
  border-radius: 16px;
  background-color: #f3f5fb;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
